const translations = {
    complete: 'Complete',
    in_progress: 'In Progress',
    not_started: 'Not Started'
};

export default translations;
